import { render, staticRenderFns } from "./chapterEdit.vue?vue&type=template&id=01c0ed81&"
import script from "./chapterEdit.vue?vue&type=script&lang=js&"
export * from "./chapterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports